import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../../shared/module/angular-material.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FilterListModule } from '../../filterlist/filterlist.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ScheduleDetailComponent } from './schedule-detail.component';
import { ApplicationPipesModule } from 'src/app/shared/module/applicationPipesModule';
import { PartTableAddModule } from '../part/component/part-table-add/part-table-add.module';
import { PartTableAvailModule } from '../part/component/part-table-avail/part-table-avail.module';
import { DynamicTableModule } from 'src/app/dynamic-table/dynamic-table.module';
import { AngularSplitModule } from 'angular-split';
import { FadeModule } from 'src/app/diagnostics/component/alert/fade/fade.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatChipsModule } from '@angular/material/chips';
import { OrderableListViewModule } from 'src/app/shared/orderable-list-view/orderable-list-view.module';
import { ScheduleCriteriaFormComponent } from './schedule-criteria-form/schedule-criteria-form.component';
import { DropdownSearchableModule } from '../../shared/dropdown-searchable/dropdown-searchable.module';
import { ScheduleVehiclesFormComponent } from './schedule-vehicles-form/schedule-vehicles-form.component';

@NgModule({
  declarations: [
    ScheduleDetailComponent,
    ScheduleCriteriaFormComponent,
    ScheduleVehiclesFormComponent
  ],
  imports: [
    CommonModule,
    MatPaginatorModule,
    FilterListModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    MatProgressBarModule,
    FilterListModule,
    ApplicationPipesModule,
    PartTableAddModule,
    PartTableAvailModule,
    DynamicTableModule,
    AngularSplitModule,
    FadeModule,
    TranslateModule,
    MatChipsModule,
    OrderableListViewModule,
    DropdownSearchableModule,
  ],
  exports: [
    ScheduleDetailComponent, 
    ScheduleCriteriaFormComponent,
    ScheduleVehiclesFormComponent
  ],
})
export class ScheduleDetailModule { }
